import { useState, useEffect } from 'react';
import { useParams, useLocation } from "react-router-dom";
import Loader from './Loader';
import Dir from './elements/Dir';
import Picture from './elements/Picture';
import FullPicture from './elements/FullPicture';
import Movie from './elements/Movie';
import BreadcrumbTrail from './elements/BreadcrumbTrail';
import { directories } from '../models/directories';
import Image from './Image';


const Directory = (props) => {
    const params = useParams();

    const [loading, setLoading] = useState(true);
    const [files, setFiles] = useState({});
    const [dir, setDir] = useState({});
    const [currentDir, setCurrentDir] = useState('');
    const [currentSubDir, setCurrentSubDir] = useState(null);
    const [currentImgId, setCurrentImgId] = useState(null);
    const fullPicture = useLocation().pathname.indexOf('/full') === 0;
    const paramsSubDir = params['*'].length > 0 ? params['*'].split('/') : [];
    const paramImg = paramsSubDir.pop();
    const newSubDir = paramsSubDir.length === 0 ? '/' : "/" + paramsSubDir.join('/') + '/';

    if (fullPicture && paramImg !== currentImgId) {
        setCurrentImgId(paramImg);
        setCurrentSubDir(paramsSubDir.length === 0 ? '/' : "/" + paramsSubDir.join('/') + '/');
    } else if (!fullPicture && currentImgId) {
        setCurrentImgId(null);
    } else if (currentSubDir !== newSubDir) {
        setCurrentSubDir(paramsSubDir.length === 0 ? '/' : "/" + paramsSubDir.join('/') + '/');
    }

    if ((params.directory + currentSubDir) !== currentDir) {
        setLoading(true);
        setCurrentDir(params.directory + currentSubDir);
        setFiles({});
    }

    useEffect(() => {
        if (currentDir && Object.keys(files).length === 0) {
            directories.getFiles(currentDir).then((data) => {
                setFiles(data.files);
                setDir(data.attributes);
                setLoading(false);
            }).catch();
        }
    });

    if (loading) {
        return <Loader />;
    }

    const elemsBlocs = [];
    let currentImgPos = -1;
    if (currentImgId === null) {
        let pos = 1;
        files.sub_directory.map((elem) => {
            elemsBlocs.push(<Dir key={"dir-" + pos} {...elem} />);
            ++pos;
        });

        files.picture.map((elem, elemPos) => {
            elemsBlocs.push(<Picture key={"dir-" + pos} {...elem} toFull={'/full/' + currentDir + elem.label} />);
            ++pos;
        });

        files.movie.map((elem) => {
            elemsBlocs.push(<Movie key={"dir-" + pos} {...elem} />);
            ++pos;
        });
    } else {
        currentImgPos = files.picture.findIndex((elem, elemPos) => {
            return elem.label === currentImgId;
        });
    }

    return <div>
        <BreadcrumbTrail dir={dir} currentDir={currentDir} onClick={() => {setCurrentImgId(null)}} />
        {
            currentImgId !== null && currentImgPos > -1 ?
                <FullPicture
                    url={files.picture[currentImgPos].url.preview}
                    urlDownload={files.picture[currentImgPos].url.full}
                    label={files.picture[currentImgPos].label}
                    nextElem={'/full/' + currentDir + (currentImgPos + 1 === files.picture.length ? files.picture[0].label : files.picture[currentImgPos + 1].label)}
                    beforeElem={'/full/' + currentDir + (currentImgPos - 1 === -1 ? files.picture[files.picture.length - 1].label : files.picture[currentImgPos - 1].label)}
                /> :
                <div className="my-grid">{elemsBlocs}</div>
        }
        </div>;
}

export default Directory;